<div
  (click)="$event.stopPropagation()"
  class="math-block-one-calendar-remainder"
>
  <div
    class="d-flex align-items-center flex-row justify-content-between pt-0 calendar-title"
    [ngClass]="{ 'border-bottom-cls': isOn }"
  >
    <div
      class="inner-first-div d-flex justify-content-between"
      [ngClass]="{ customWidth: isOn }"
    >
      <div class="math_ui-remind-on">
        {{ "REMIND_ON" | translate }}
      </div>

      <mat-slide-toggle
        class="mat-slide-toggle d-flex align-items-end ms-2"
        (change)="emitDataObj()"
        [(ngModel)]="isOn"
      >
      </mat-slide-toggle>
    </div>
    <div class="inner-second-div"></div>
  </div>
  <div *ngIf="isOn" class="reminder-block">
    <div class="d-flex">
      <div class="left-side-blocking" (click)="$event.stopPropagation()">
        <div class="position-relative" (click)="$event.stopPropagation()">
          <mat-calendar
            [(selected)]="selectedDueDate"
            (selectedChange)="emitDataObj();resetHours()"
            [minDate]="minDate"
          ></mat-calendar>
        </div>
      </div>
      <div class="border-full"></div>
      <div class="right-side-blocking">
        <div class="mx-3">

            <div class="typo-text font-12 font-color-cls mt-2">Reminder Start Date</div>
            <div class="px-0 cmn-txt text-cmns">
              <span *ngIf="selectedDueDate"> {{ (selectedDueDate | date : "MMM d, y")  }}</span>
              <span *ngIf="!selectedDueDate" class="custom-place">Select date</span>
            </div>

            <div class="time d-flex mt-2 row g-0">
              <div class="col-6">
                <div class="typo-text font-12 font-color-cls">
                  Update Reminder Time
                </div>
                <div class="d-flex">
                  <select
                    [(ngModel)]="selectedHour"
                    name="selectedHour" class="reminder-hour"
                    (change)="timeSelection()" placeholder="Select hour"
                  >
                  <option [ngValue]="null" disabled selected>HH</option>
                    <option *ngFor="let hour of hours" [value]="hour">
                      {{ hour }}
                    </option>
                  </select>
                  <select
                    [(ngModel)]="selectedMinute"
                    name="selectedMinute" class="reminder-hour"
                    (change)="timeSelection()"
                  >
                  <option [ngValue]="null" disabled selected>mm</option>
                    <option *ngFor="let minute of minutes" [value]="minute">
                      {{ minute }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-6" *ngIf="selectedTime">
                <div class="typo-text font-12 font-color-cls">Selected Reminder Time</div>
                 <div class="selected-time-cls">{{selectedTime}}</div>
              </div>
            </div>
          <div class="position-relative mt-2">
            <mat-label hidden></mat-label>
            <div class="typo-text font-12 font-color-cls mb-1">Reminder Get</div>
            <ul class="list-unstyled a-r-list mb-2">
              <mat-checkbox
                class="example-margin c-checkbox-button"
                [checked]="isAllChecked(remindTo)"
                (change)="allSelect(remindTo, $event)"
                >All</mat-checkbox
              >
              <li *ngFor="let list of remindTo">
                <mat-checkbox
                  class="example-margin c-checkbox-button"
                  (change)="optionClick(list, $event)"
                  [(ngModel)]="list['checked']"
                  >{{ list.label }}</mat-checkbox
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="mx-3 border-bottom-cls mb-0">
          <div class="typo-text font-12 font-color-cls">Select Frequency</div>
          <div class="d-flex justify-content-between mt-1">
            <div class="d-flex">
              <img
                alt="revert-icon"
                src="./assets/images/bluereverticon.svg"
                class="mr-2"
              />
              <mat-select
                name="frequency range"
                [value]="selectedFrequency"
                [(ngModel)]="selectedFrequency"
                placeholder="Select"
                class="typo-text"
              >
                <mat-option
                  *ngFor="let ele of frequency"
                  [value]="ele.value"
                  (onSelectionChange)="selectFrequency(ele, $event)"
                >
                  {{ ele.name }}
                </mat-option>
              </mat-select>
            </div>
            <div
              *ngIf="selectedFrequency && selectedFrequency !== 'once'"
              class="input-mat"
            >
              <input
               class="placeholder-color pc"
                matInput
                type="number"
                [min]="1"
                [placeholder]="selectedFrequency == 'hourly' ? 'Hours' : 'Days'"
                [(ngModel)]="repeatValue"
              />
            </div>
          </div>
        </div>
        <div class="mx-3 reminder-notify">
          <div class="position-relative">
            <mat-label hidden></mat-label>
            <div class="typo-text font-12 font-color-cls mb-1">Reminder On</div>
            <ul class="list-unstyled a-r-list">
              <mat-checkbox
                class="example-margin c-checkbox-button"
                [checked]="isAllChecked(reminderOption)"
                (change)="allSelect(reminderOption, $event)"
                >All</mat-checkbox
              >
              <li *ngFor="let list of reminderOption">
                <mat-checkbox
                  class="example-margin c-checkbox-button"
                  (change)="optionClick(list, $event)"
                  [(ngModel)]="list['checked']"
                  >{{ list.name }}</mat-checkbox
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-week-width">
      <div class="d-flex justify-content-between custom-working-hour-cls font-cls">
        <span class="ms-2">Manually Include Day & Time</span>
        <span *ngIf="isTimesheetOn">Set Timesheet Working hours <mat-checkbox class="ms-1" (change)="getTimesheetSettings($event)"></mat-checkbox></span>
      </div>
      <form [formGroup]="scheduleForm">
        <table class="table table-bordered text-center">
          <thead>
            <tr>
              <th class="font-cls" *ngFor="let ctrl of days.controls; let i = index" [formGroup]="ctrl">
                <mat-checkbox class="example-margin c-checkbox-button ctm-checkbox-button task-reminder-checkbox"
                formControlName="isCheck" (change)="autoPatchTime(i)"
                    >{{ ctrl.value.day_sortname }}</mat-checkbox>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td *ngFor="let ctrl of days.controls" [formGroup]="ctrl" [ngClass]="!ctrl.value.isCheck ? 'disabled-cls': ''">
                <input type="time" formControlName="from" 
                       [disabled]="!ctrl.value.isCheck" class="form-control"/>
              </td>
            </tr>
            <tr>
              <td *ngFor="let ctrl of days.controls" [formGroup]="ctrl" [ngClass]="!ctrl.value.isCheck ? 'disabled-cls': ''">
                <input type="time" formControlName="to" 
                       [disabled]="!ctrl.value.isCheck" class="form-control"/>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>


    <div class="d-flex border-top-cls footer-calendar">
      <div class="text-left">
        <a class="anchor-link float-end" (click)="clearData()">Clear all</a>
      </div>
      <div class="text-right">
        <button
          class="anchor-link float-end math_ui-text"
          (click)="emitDataObj(true)"
          [ngClass]="{ isGrey: isValidForm() }"
          style="border: none"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</div>
